import React from 'react';
import PropTypes from 'prop-types';
import CatalogProductGrid from './CatalogProductGrid';
// import BreadcrumbCatalog from './BreadcrumbCatalog';
import './CatalogDetail.css';

const CatalogDetail = props => (
  <div className="column catalog-detail">
    {/*<BreadcrumbCatalog categories={props.categories} {...props} />*/}
    <CatalogProductGrid {...props} />
  </div>
);

CatalogDetail.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

CatalogDetail.defaultProps = {
  location: {
    pathname: '/catalog',
  },
};

export default CatalogDetail;



// WEBPACK FOOTER //
// ./src/components/CatalogDetail.js